import { z } from "zod";

export const environmentalChecklistItem = z
  .object({
    value: z.string().min(1, "Required"),
    comment: z.string().optional(),
    ticket: z.string().optional(),
    ticketBody: z.string().optional(),
  })
  .refine(
    (data) =>
      !(
        data.value === "No" &&
        (data.ticket ?? "No" === "No") &&
        data.comment === ""
      ),
    {
      message: "Comment is required",
      path: ["comment"],
    },
  );

export const environmentalChecklistItemWithTicket = environmentalChecklistItem
  .refine(
    (data) =>
      !(
        data.value === "No" &&
        (data.ticket === "" || data.ticket === undefined)
      ),
    {
      message: "Required",
      path: ["ticket"],
    },
  )
  .refine((data) => !(data.ticket === "Yes" && data.ticketBody === ""), {
    message: "Ticket description is required.",
    path: ["ticketBody"],
  });
